import React, { useEffect } from 'react';
import Button from './Button';

import '../stylesheets/C.scss';

import { useYouTube } from '../hooks';

function C(props) {
  const youTubeAPIPromise = useYouTube();

  useEffect(() => {
    youTubeAPIPromise.then((yt) => {
      let player = new yt.Player('yt-wild-in-alaska', {
        height: '360',
        width: '640',
        videoId: 'IvprOBImYtc',
        playerVars: { rel: 0, enablejsapi: 1, autoplay: 1, mute: 1, listType: 'playlist', list: 'PL2LNe5vmCj3ayzzIAEMHmq0s7BS47cdTj', loop: 1 },
        title: 'Wild In Alaska',
      });
    });
  }, [youTubeAPIPromise]);

  return (
    <section className="c">
      <div className="video-section">
        <div className="pie-video" id="yt-wild-in-alaska">
          <div id="pie-yt-video"></div>
        </div>
      </div>
      <div className="top-section">
        <h1>Monetary Wealth Doesn't Define people in Alaska</h1>
        <h2>
          Emma and Claire, Salmon Sisters founders, are focused on commercial fishing and supporting their community. See how they are reimagining wealth for themselves and fellow
          Alaskans.
        </h2>
      </div>
      <Button message={'Learn More'} link={`${props.stagingUrl}generations-of-wealth/`} />
    </section>
  );
}

export default C;
